import { post, del, get } from './api_helper';
export const authLoginUser = (userData) => post('/login', userData);
export const authLogoutUser = () => del('/logout');
export const googleLoginUser = (accessToken) =>
  get('web_google_signin', {
    params: accessToken
  });
